export default __webpack_public_path__ + "static/media/tag.2b55551d.png";